export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1e3a8a] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <path d="M0,0 L100,0 L100,100 L0,100 Z" fill="none" stroke="#c53030" strokeWidth="0.5" />
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-12">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/5c0ad1e95b49fc3621673298b03cd410/cee89e20f7d26bfc174a546f85a70f24.png"
              alt="Drive With US"
              className="h-16 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-white/80 mb-6 font-serif italic text-lg">
              Transformando viagens em memórias inesquecíveis
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="Seu e-mail"
                className="flex-1 px-4 py-2 rounded-lg bg-transparent border border-white/30 text-white placeholder:text-white/50 focus:outline-none focus:border-white"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-[#c53030] rounded-lg hover:bg-[#a02525] transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </button>
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Frota</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('frota')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Pacifica Hybrid
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('frota')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Pacifica Gas
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('frota')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Honda Odyssey
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('frota')} className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Mitsubishi Outlander
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Serviços</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  Seguros
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  Extras
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  Entrega
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors">
                  Suporte 24/7
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Contato</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-white/80">
                <i className="ri-phone-line"></i>
                <span>+1 (321) 594 9330</span>
              </li>
              <li className="flex items-center gap-2 text-white/80">
                <i className="ri-mail-line"></i>
                <span>dwusrental@gmail.com</span>
              </li>
              <li className="flex items-center gap-2 text-white/80">
                <i className="ri-whatsapp-line"></i>
                <a 
                  href="https://wa.me/13215949330"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/80">
                <i className="ri-instagram-line"></i>
                <a 
                  href="https://instagram.com/drivewitusoficial" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  @drivewitusoficial
                </a>
              </li>
              <li className="flex items-center gap-2 text-white/80">
                <i className="ri-map-pin-line"></i>
                <span>Orlando, FL</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/60 text-sm">
            © 2024 Drive With US. Registered Florida Company. Todos os direitos reservados.
          </p>

          <div className="flex items-center gap-4">
            <a
              href="https://instagram.com/drivewitusoficial"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors"
            >
              <i className="ri-instagram-line"></i>
            </a>
            <a
              href="https://wa.me/13215949330"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:bg-white/10 transition-colors"
            >
              <i className="ri-whatsapp-line"></i>
            </a>
          </div>

          <div className="flex items-center gap-4 text-sm">
            <a href="#" className="text-white/60 hover:text-white transition-colors">
              Privacidade
            </a>
            <a href="#" className="text-white/60 hover:text-white transition-colors">
              Termos
            </a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
